module.exports = __webpack_public_path__ + "static/muli-v16-latin-regular-8160dac0c3b1b1cedd4299fe5fff9b6b.woff2";